import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { getDocumentNumber } from '../../../../@core/common/global';
import { ApiService } from '../../../../@core/service/api.service';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import { CompilationModel } from '../../../../@models/erp/compilation';
import { CompilationTypeData } from '../../../../@models/erp/compilationData';
import { DocumentSelectComponent } from './document-select.component';

@Component({
  selector: 'ngx-document-spo-selector',
  templateUrl: '../document-select/document-select.component.html',
  styleUrls: ['../document-select/document-select.component.scss'],
})
export class DocumentSpoSelectorComponent extends DocumentSelectComponent {

  constructor(private datePipe: DatePipe, public api: ApiService, public data: SharedDataService) {
    super(data);
  }

  preFilter(items: CompilationModel[]): CompilationModel[] {
    return items.filter(f => !f.draft);
  }
  
  async ngOnInit() {
    this.initialItems = this.preFilter(
      (await this.api.getAllVersionData(
        false,
        true,
        ['code', 'version', 'draft', 'nameOverride', 'exwJapanDate', 'arrivingVieDate', 'internal', 'lineItems.tbCode'],
        '^(PFSPONRK|SPONRKA)',
      )) as CompilationModel[]
    );
    this.initialItems.forEach(el => el['obic'] = el['obics'].join(','));
    this.latestVersionItems = [...this.initialItems];
  }

  columns = [
    { id: 'code', title: 'Document number', search: '' },
    { id: 'recipient', title: 'Recipient', search: '' },
    { id: 'exwJapanDate', title: 'EXW date', search: '' },
    { id: 'arrivingVieDate', title: 'ETA AT date', search: '' },
    { id: 'internal', title: 'Internal', search: '' },
    { id: 'obic', title: 'OBIC', search: '' },
  ]

  getText(col: string, item: CompilationModel) {
    if (!item) return '';
    switch (col) {
      case 'code': return getDocumentNumber(item);
      case 'recipient': return (item.recipient || {})['name'];
      case 'arrivingVieDate':
      case 'exwJapanDate': return this.datePipe.transform(item[col], 'yyyy-MM-dd')
      default: return item[col];
    }
  }

  // preFilter(items: CompilationModel[]) {
  //   return items.filter(f =>
  //     +f.type === CompilationTypeData.get('PFSPO').id
  //     || +f.type === CompilationTypeData.get('SPO').id
  //   );
  // }

}

